import styled from 'styled-components';
import { Colors } from '../../values/colors';

export const PageWrapper = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  @media (max-width: 1024px) { grid-template-columns: repeat(2, 1fr); }
`;

export const SummaryCard = styled.div`
  background: ${({ accent }) => accent ? Colors.primaryBlue + '18' : Colors.ultraLightGray3};
  border: 1px solid ${({ accent }) => accent ? Colors.primaryBlue + '55' : Colors.ultraLightGray};
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SummaryLabel = styled.span`
  font-size: 11px;
  color: ${Colors.mutedGray};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SummaryValue = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: ${({ accent }) => accent ? Colors.primaryBlue : Colors.blueGray};
`;

export const SummarySubtext = styled.span`
  font-size: 12px;
  color: ${Colors.mutedGray};
  margin-top: 2px;
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FilterLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  color: ${Colors.mutedGray};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const FilterInput = styled.input`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  width: ${({ width }) => width || '200px'};
  background: ${Colors.white};
  height: 36px;
  &:focus { border-color: ${Colors.primaryBlue}; }
  &::placeholder { color: ${Colors.lightGray}; }
`;

export const FilterSelect = styled.select`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  width: ${({ width }) => width || '180px'};
  background: ${Colors.white};
  height: 36px;
  cursor: pointer;
  &:focus { border-color: ${Colors.primaryBlue}; }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid ${Colors.ultraLightGray};
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
`;

export const Th = styled.th`
  background: ${Colors.ultraLightGray3};
  color: ${Colors.mutedGray};
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 12px 10px;
  text-align: ${({ center, right }) => center ? 'center' : right ? 'right' : 'left'};
  white-space: nowrap;
  ${({ w }) => w ? `width: ${w}; min-width: ${w};` : ''}
`;

export const Td = styled.td`
  padding: 13px 10px;
  color: ${({ muted }) => muted ? Colors.mutedGray : Colors.blueGray};
  border-bottom: 1px solid ${Colors.ultraLightGray2};
  text-align: ${({ center, right }) => center ? 'center' : right ? 'right' : 'left'};
  font-weight: ${({ bold }) => bold ? '700' : '400'};
  font-size: ${({ muted }) => muted ? '13px' : '14px'};
  white-space: nowrap;
  ${({ w }) => w ? `width: ${w}; min-width: ${w};` : ''}
  ${({ ellipsis, w }) => ellipsis ? `max-width: ${w || '140px'}; overflow: hidden; text-overflow: ellipsis;` : ''}
`;

export const MinBadge = styled.span`
  display: inline-block;
  background: ${Colors.yellow}33;
  color: #b07800;
  border: 1px solid ${Colors.yellow}88;
  border-radius: 20px;
  padding: 2px 9px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid ${({ color }) => Colors[color] || Colors.successGreen};
  color: ${({ color }) => Colors[color] || Colors.successGreen};
  background: ${({ color }) => (Colors[color] || Colors.successGreen) + '18'};
`;

export const RuleTag = styled.span`
  display: inline-block;
  background: ${Colors.ultraLightGray2};
  color: ${Colors.blueGray2};
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 500;
`;

export const ServiceTag = styled.span`
  display: inline-block;
  background: ${Colors.primaryBlue}14;
  color: ${Colors.primaryBlue};
  border: 1px solid ${Colors.primaryBlue}44;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

// Grupo de botões segmentados (ex.: Todas / Ativas / Inativas).
export const SegmentGroup = styled.div`
  display: inline-flex;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  overflow: hidden;
  height: 36px;
  background: ${Colors.white};
`;

export const SegmentButton = styled.button`
  border: none;
  background: ${({ active }) => active ? Colors.primaryBlue : 'transparent'};
  color: ${({ active }) => active ? '#fff' : Colors.mutedGray};
  font-size: 13px;
  font-weight: 600;
  padding: 0 16px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  & + & { border-left: 1px solid ${Colors.ultraLightGray}; }
  &:hover { background: ${({ active }) => active ? Colors.primaryBlue : Colors.ultraLightGray3}; }
`;

export const FilterToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  background: ${({ active, tone }) => active ? (tone || Colors.orange) + '18' : Colors.white};
  color: ${({ active, tone }) => active ? (tone || Colors.orange) : Colors.mutedGray};
  border: 1px solid ${({ active, tone }) => active ? (tone || Colors.orange) + '88' : Colors.ultraLightGray};
  &:hover { border-color: ${({ tone }) => (tone || Colors.orange)}88; }
`;

export const ActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: ${({ variant }) =>
    variant === 'primary' ? Colors.primaryPurple :
    variant === 'danger'  ? Colors.red :
    variant === 'outline' ? 'transparent' : Colors.ultraLightGray2};
  color: ${({ variant }) =>
    variant === 'primary' ? '#fff' :
    variant === 'danger'  ? '#fff' :
    variant === 'outline' ? Colors.primaryBlue : Colors.blueGray};
  border: 1px solid ${({ variant }) =>
    variant === 'primary' ? Colors.primaryPurple :
    variant === 'danger'  ? Colors.red :
    variant === 'outline' ? Colors.primaryBlue : Colors.ultraLightGray};
  border-radius: 8px;
  padding: ${({ small }) => small ? '4px 10px' : '8px 16px'};
  font-size: ${({ small }) => small ? '12px' : '13px'};
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s;
  &:hover { opacity: 0.82; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 14px 4px 4px;
  border-top: 2px solid ${Colors.ultraLightGray};
`;

export const TotalLabel = styled.span`
  font-size: 14px;
  color: ${Colors.mutedGray};
  font-weight: 500;
`;

export const TotalValue = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: ${Colors.blueGray};
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;
  margin-bottom: 24px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const DetailLabel = styled.span`
  font-size: 11px;
  color: ${Colors.mutedGray};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const DetailValue = styled.span`
  font-size: 15px;
  font-weight: ${({ bold }) => bold ? '700' : '500'};
  color: ${Colors.blueGray};
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  border-left: 2px solid ${Colors.ultraLightGray};
  margin-left: 8px;
  padding-left: 16px;
`;

export const HistoryItem = styled.div`
  position: relative;
  padding-bottom: 16px;
  &::before {
    content: '';
    position: absolute;
    left: -22px;
    top: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ error }) => error ? Colors.red : Colors.primaryBlue};
    border: 2px solid #fff;
  }
`;

export const HistoryTime = styled.span`
  font-size: 11px;
  color: ${Colors.mutedGray};
  font-weight: 600;
`;

export const HistoryEvent = styled.p`
  font-size: 13px;
  color: ${Colors.blueGray};
  margin: 2px 0 0;
`;

export const FormSection = styled.div`
  border-top: 1px solid ${Colors.ultraLightGray};
  padding-top: 20px;
  margin-top: 20px;
`;

export const FormSectionTitle = styled.h3`
  font-size: 13px;
  font-weight: 700;
  color: ${Colors.blueGray};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => cols === 3 ? 'repeat(3, 1fr)' : cols === 1 ? '1fr' : 'repeat(2, 1fr)'};
  gap: 16px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${Colors.blueGray};
`;

export const FormInput = styled.input`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  background: ${Colors.white};
  &:focus { border-color: ${Colors.primaryBlue}; }
  &::placeholder { color: ${Colors.lightGray}; }
`;

export const FormSelect = styled.select`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  background: ${Colors.white};
  cursor: pointer;
  &:focus { border-color: ${Colors.primaryBlue}; }
`;

export const FormTextarea = styled.textarea`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  background: ${Colors.white};
  resize: vertical;
  min-height: 72px;
  &:focus { border-color: ${Colors.primaryBlue}; }
`;

export const TierRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 8px;
`;

export const TierCard = styled.div`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  background: ${Colors.white2};

  ${TierRow} {
    margin-bottom: 0;
  }
`;

export const FormHint = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: ${Colors.mutedGray};
`;

export const ConfirmGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
`;

export const ConfirmRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid ${Colors.ultraLightGray2};
  font-size: 14px;
`;

export const ConfirmKey = styled.span`
  color: ${Colors.mutedGray};
  font-weight: 500;
`;

export const ConfirmVal = styled.span`
  color: ${Colors.blueGray};
  font-weight: ${({ bold }) => bold ? '700' : '500'};
`;
